import React from "react";
import "./ProcessSteps.css";

const ProcessSteps = ({ title, steps }) => {
  return (
    <div className="process-steps-container">
      <h1 className="process-title">{title}</h1>
      <div className="steps-list">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className="step-item">
              <span className="step-badge">STEP {index + 1}</span>
              <h2 className="step-main-title">{step.title}</h2>

              {step.details && (
                <div className="step-details-wrapper">
                  {step.details.map((detail, detailIndex) => (
                    <div key={detailIndex} className="detail-block">
                      <h3 className="detail-subtitle">{detail.subtitle}</h3>
                      <ul className="detail-list">
                        {detail.items.map((item, itemIndex) => (
                          <li key={itemIndex}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {index < steps.length - 1 && (
              <div className="step-arrow">
                <img src="./images/gray-arrow-down.png" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProcessSteps;
